export default Object.freeze({
  0: 'Unknown',
  1: 'Image',
  2: 'Video',
  3: 'Pdf',
  4: 'Word',
  5: 'Excel',
  6: 'PowerPoint',
  7: 'MicrosoftProject',
  8: 'Text',
  9: 'Xml',
  10: 'Html',
  11: 'Json',
  12: 'Zip',
  13: 'Audio',
  14: 'Rar',
  15: 'Font',
  16: 'TextCsv',
  17: 'AndroidAPK',
  18: 'ExcelFile',
  19: 'ParquetFile',
  20: 'OutlookMessage',
});
